import DynamicForm from '../components/dynamicForm';

const Ambassadors = () => {
  const fields = [
    { id: 'name', type: 'text', placeholder: 'الاسم', required: true },
    { id: 'mobile', type: 'phone', placeholder: 'رقم الجوال', required: true },
    { id: 'city', type: 'text', placeholder: 'المدينة', required: true },
    { id: 'motive', type: 'textarea', placeholder: 'دافعك للتقديم', required: true },
    {
      id: 'socialMedia',
      type: 'select',
      placeholder: 'اختر منصة التواصل الاجتماعي',
      options: [
        { label: 'انستغرام', value: 'instagram' },
        { label: 'إكس', value: 'x' },
        { label: 'تيك توك', value: 'tiktok' },
        { label: 'سناب شات', value: 'snapchat' },
      ],
      required: true,
    },
    {
      id: 'instagram',
      type: 'social-media',
      placeholder: 'انستغرام',
      dependentOn: 'socialMedia',
      dependencyValues: ['instagram'], // Will show only when Instagram is selected
      required: true,
    },
    {
      id: 'x',
      type: 'social-media',
      placeholder: 'إكس',
      dependentOn: 'socialMedia',
      dependencyValues: ['x'], // Will show only when Twitter is selected
      required: true,
    },
    {
      id: 'tiktok',
      type: 'social-media',
      placeholder: 'تيك توك',
      dependentOn: 'socialMedia',
      dependencyValues: ['tiktok'], // Will show only when TikTok is selected
      required: true,
    },
    {
      id: 'snapchat',
      type: 'social-media',
      placeholder: 'سناب شات',
      dependentOn: 'socialMedia',
      dependencyValues: ['snapchat'], // Will show only when Snapchat is selected
      required: true,
    },
  ];

  return (
    <DynamicForm
      formType="Ambassadors"
      fields={fields}
      title="سفراء"
      introText={[
        "نحن في {brand} نبحث دائمًا عن المؤثرين وصناع المحتوى المبدعين للانضمام إلى مجتمعنا المميز. إذا كنت شغوفًا بعالم الموضة وأسلوب الحياة وتؤمن بقيم {brand}، فنحن نود أن نسمع منك!",
        "للتقديم، نطلب منك:",
        "•أن تكون متوافقًا مع رؤية وأسلوب {brand}.",
        "•أن تستمتع بإنشاء محتوى أصيل يبرز منتجاتنا. ",
        "•أن يكون لديك قاعدة متابعين لا تقل عن 2,000 متابع . ",
        "للانضمام، أخبرنا عن:"
      ].join("\n")}
      />
  );
};

export default Ambassadors;
